"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryInstance = exports.getInstance = exports.setFactory = exports.cachedInstance = void 0;
let registeredFactory = () => {
    throw new Error(`Assertion failed: No libzip instance is available, and no factory was configured`);
};
function setFactory(factory) {
    registeredFactory = factory;
}
exports.setFactory = setFactory;
function getInstance() {
    if (typeof exports.cachedInstance === `undefined`)
        exports.cachedInstance = registeredFactory();
    return exports.cachedInstance;
}
exports.getInstance = getInstance;
function tryInstance() {
    return exports.cachedInstance;
}
exports.tryInstance = tryInstance;
